import React, { useEffect, useState } from 'react';
import { FieldHelperProps, FieldHookConfig, FieldInputProps, FieldMetaProps, useField, useFormikContext } from 'formik';

export function useFastField<Val>(
    // note: FieldHookConfig.parser et .format viennent avec formik 3.0.0
    propsOrFieldName: (string | FieldHookConfig<Val>) & { parser?: (v: Val) => Val },
): [FieldInputProps<Val>, FieldMetaProps<Val>, FieldHelperProps<Val>] {
    const { parser } = propsOrFieldName;
    const [field, meta, helpers] = useField<Val>(propsOrFieldName);
    const [value, setValue] = useState<Val>(field.value);
    const { onBlur, onChange } = field;
    const { setValue: helpersSetValue } = helpers;
    const { isSubmitting } = useFormikContext();

    const currentFieldValue = field.value;

    // resync field.value
    useEffect(() => {
        if (currentFieldValue !== value) {
            setValue(currentFieldValue);
        }
    }, [currentFieldValue]);

    useEffect(() => {
        helpers.setValue(value, true);
    }, [isSubmitting]);

    // monkey patch formik field
    field.value = value;
    field.onChange = (e: React.ChangeEvent<{ value: Val }>): void => {
        if (e && e.currentTarget) {
            setValue(e.currentTarget.value);
        }
    };
    field.onBlur = (e) => {
        onChange(e);
        setTimeout(() => onBlur(e), 0);
    };

    helpers.setValue = (value, shouldValidate) => {
        const parsedValue = parser ? parser(value) : value;
        setValue(parsedValue);
        helpersSetValue(value);
        setTimeout(() => helpers.setTouched(meta.touched || !!value, shouldValidate), 0);
    };

    return [field, meta, helpers];
}
